import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary" }, "Confere com a escala", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-neutral50 mt-0.5",
  "data-testid": "conference-subtitle"
}
const _hoisted_4 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_5 = { class: "rounded-lg border border-lightGray30 border-l-4 border-l-primary30 bg-gray-50 p-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-wide text-neutral50 mb-1" }, " Conferência da folha do operador ", -1)
const _hoisted_7 = {
  class: "text-sm text-textPrimary",
  "data-testid": "conference-text"
}
const _hoisted_8 = { class: "flex items-start gap-2 rounded-lg border-2 border-primary30 bg-primary5/40 p-3 cursor-pointer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Li e confirmo a conferência da folha acima"),
  /*#__PURE__*/_createElementVNode("span", { class: "block text-neutral50 mt-0.5" }, " Obrigatório. Sem esta marcação o botão Confirmar permanece desabilitado. ")
], -1)
const _hoisted_10 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-2" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = { class: "text-[10px] font-bold uppercase tracking-wide text-neutral50 mt-1" }
const _hoisted_13 = { class: "text-[9px] font-mono text-neutral50" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] text-neutral50" }, " A linha “não consta na folha” entra na fila de divergências para tratamento no pagamento — não desaparece. ", -1)
const _hoisted_15 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { computed, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import {
  PrefillOutcome,
  PREFILL_OUTCOME_TALLY_LABELS,
  SHEET_CONFERENCE_TEXT
} from '@/constants/ds-attendance.constants'
import type { PrefillOutcomeTally } from '../utils/prefill-mirror'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceSheetConferenceModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean },
    tally: {},
    subtitle: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * ESP-02/29-04, decisões 5 e 7 do grilling — o OK global embute UMA conferência da folha,
 * com checkbox obrigatório, e é exigido mesmo com 100% auto-conciliado pelo motor: o motor
 * confere horário × escala, o humano atesta a folha física.
 *
 * NOMENCLATURA: "Conferência da folha" / "Confirmar conferência". NUNCA "atestado" — no
 * domínio do produto isso é atestado médico.
 */




const signaturesChecked = ref(false)

/** Reabrir o modal nunca herda a marcação anterior: a conferência é um ato por vez. */
watch(
  () => props.modelValue,
  (open) => {
    if (!open) signaturesChecked.value = false
  }
)

const TALLY_STYLES: Record<PrefillOutcome, { border: string; text: string; code: string }> = {
  [PrefillOutcome.CONFIRMED]: {
    border: 'border-t-sucess',
    text: 'text-sucess',
    code: 'CONFIRMED'
  },
  [PrefillOutcome.EDITED]: { border: 'border-t-alert', text: 'text-alert', code: 'EDITED' },
  [PrefillOutcome.ABSENT]: {
    border: 'border-t-negative',
    text: 'text-negative',
    code: 'ABSENT → DIVERGENT'
  },
  [PrefillOutcome.EXTRA]: { border: 'border-t-primary30', text: 'text-primary30', code: 'EXTRA' }
}

const tallyCards = computed(() =>
  Object.values(PrefillOutcome).map((outcome) => ({
    outcome,
    count: props.tally[outcome] ?? 0,
    label: PREFILL_OUTCOME_TALLY_LABELS[outcome],
    code: TALLY_STYLES[outcome].code,
    borderClass: TALLY_STYLES[outcome].border,
    textClass: TALLY_STYLES[outcome].text
  }))
)

function close() {
  emit('update:modelValue', false)
}

/**
 * Guarda de UI espelhando o 400 do backend: sem a conferência marcada nenhuma requisição
 * sai daqui — o botão desabilitado é a primeira barreira, esta é a segunda.
 */
function confirm() {
  if (!signaturesChecked.value) return
  emit('confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[720px]",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (close()))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "conference-cancel-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
        }),
        _createVNode(FilledButton, {
          text: "Confirmar conferência",
          class: "bg-primary30",
          width: "220px",
          height: "40px",
          disabled: !signaturesChecked.value || _ctx.saving,
          "data-testid": "conference-confirm-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (confirm()))
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, " “" + _toDisplayString(_unref(SHEET_CONFERENCE_TEXT)) + "” ", 1)
        ]),
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((signaturesChecked).value = $event)),
            type: "checkbox",
            class: "mt-0.5",
            "data-testid": "conference-checkbox"
          }, null, 512), [
            [_vModelCheckbox, signaturesChecked.value]
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tallyCards.value, (card) => {
            return (_openBlock(), _createElementBlock("div", {
              key: card.outcome,
              class: _normalizeClass(["rounded-lg border border-lightGray30 border-t-[3px] p-2", card.borderClass]),
              "data-testid": `conference-tally-${card.outcome}`
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-lg font-bold leading-none", card.textClass])
              }, _toDisplayString(card.count), 3),
              _createElementVNode("p", _hoisted_12, _toDisplayString(card.label), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(card.code), 1)
            ], 10, _hoisted_11))
          }), 128))
        ]),
        _hoisted_14
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})